
import { Component, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import {
    apiSupplyModelLists,
    apiModelList,
    apiModelFastEdit,
    apiSupplyModelSetPrice,
    apiSupplyModelSetCommission,
    apiGetSupplyCommissionLog,
    apiModelModelSupplyDeleteSupplyPrice,
} from "@/api/model";
import { apiShopLists } from "@/api/shop";
import ShopList from "@/components/shop-list.vue";

@Component({
    components: {
        lsPagination,
        ShopList,
    },
})
export default class SupplyModelList extends Vue {
    /** S Data **/
    $refs!: {
        [key: string]: any;
    };
    pager: RequestPaging = new RequestPaging();
    dialogPager: RequestPaging = new RequestPaging();
    ids = [];
    sids: any = [];
    searchForm: any = { ids: "", sids: "", model_code: "" };
    modelList: any[] = [];
    shopList: any[] = [];

    apiSupplyModelLists = apiSupplyModelLists;

    logDialogVisible = false;
    logData: any[] = [];

    specDialogVisible = false;
    specData: any[] = [];
    model_item_ids: any = [];
    supply_price_list: any[] = [];
    supply_price = "";
    shopListDesc = "";
    selectionData: any = [];

    /** E Data **/
    handlePriceHide(index: any) {
        this.selectionData = [];
        const refs = this.$refs["priceTableRef_" + index] as HTMLFormElement;
        refs.clearSelection();
        this.$forceUpdate();
    }
    specDialogCloseCb() {
        this.$set(this,'supply_price_list',[])
    }
    handlePriceChange(e: any) {
        this.selectionData = e;
    }

    deletePriceByShop(
        id: number | string,
        faterIndex: number,
        childIndex: number | string
    ) {
        let supply_price_ids: any = [];
        if (id) {
            supply_price_ids.push(id);
        } else {
            supply_price_ids = this.selectionData.map((item: any) => item.id);
        }

        apiModelModelSupplyDeleteSupplyPrice({ supply_price_ids }).then(
            (res: any) => {
                this.getList();
                console.log(faterIndex, "........", childIndex);
                // childIndex 不存在 则批量删除
                if (childIndex === "") {
                    console.log(22222);
                    // 批量删除
                    const indexArr: any = [];
                    this.specData[faterIndex].supply_price_list.forEach(
                        (v: any, i: number) => {
                            supply_price_ids.forEach(
                                (item: any, index: number) => {
                                    if (v.id === item) {
                                        indexArr.push(i);
                                    }
                                }
                            );
                        }
                    );
                    indexArr
                        .sort((a: any, b: any) => b - a)
                        .forEach((index: any) => {
                            this.specData[faterIndex].supply_price_list.splice(
                                index,
                                1
                            );
                        });
                } else {
                    console.log(1111);
                    this.specData[faterIndex].supply_price_list.splice(
                        childIndex,
                        1
                    );
                }
                this.$forceUpdate();
            }
        );
    }

    getList() {
        this.searchForm.ids = this.ids.join(",");
        this.searchForm.sids = this.sids.join(",");
        this.pager.request({
            callback: apiSupplyModelLists,
            params: {
                ...this.searchForm,
            },
        });
    }

    // 重置搜索
    reset(): void {
        this.searchForm.ids = "";
        this.searchForm.sids = "";
        this.searchForm.page = 1;
        this.ids = [];
        this.sids = [];
        this.getList();
    }
    handleChangeValue(id: number, value: number, key: string) {
        apiModelFastEdit({ id: Number(id), [key]: value }).then((res: any) => {
            this.$message.success("success");
            this.getList();
        });
    }
    getModelList() {
        apiModelList({ page_size: 9999 }).then((res) => {
            this.modelList = res.lists;
        });
    }
    getShopList() {
        apiShopLists({ page_size: 9999 }).then((res) => {
            this.shopList = res.lists;
        });
    }
    handleShopConfirm(value: any) {
        this.$set(this,'supply_price_list',[])
        for (let s of value) {
            this.supply_price_list.push({
                sid: s.id,
                supply_price: this.supply_price,
            });
        }
        this.setMultiPrice();
    }
    async handleSave(item: any) {
        await this.$prompt("请输入变更描述", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
        }).then((res: any) => {
            if (res.action === "confirm") {
                if (!res.value) return this.$message.error("请输入变更描述");
                apiSupplyModelSetCommission({
                    goods_id: item.id,
                    supply_commission: item.supply_commission,
                    supply_status: item.supply_status,
                    desc: res.value,
                }).then((res: any) => {
                    this.getList();
                });
            }
        });
    }
    getSupplyCommissionLog(id: number) {
        apiGetSupplyCommissionLog({ goods_id: id, page_size: 9999 }).then(
            (res) => {
                this.logData = res.lists;
                this.logDialogVisible = true;
            }
        );
    }
    getGoodsDetail(value: any) {
        return value?.goods_detail?.items
            ? typeof value?.goods_detail?.items === "string"
                ? JSON.parse(value?.goods_detail?.items)
                : value?.goods_detail?.items
            : [];
    }

    handleEditSpec(row: any) {
        this.specData = row.model_items;
        this.specDialogVisible = true;
    }
    handleSpecChange(value: any) {
        this.model_item_ids = value.map((item: any) => item.id);
    }
    setPriceByShop(model_item_id: number, supply_price: any, sid: number) {
        this.model_item_ids = [model_item_id];
        this.supply_price_list = [
            {
                supply_price,
                sid,
            },
        ];
        this.setSupplyPrice();
    }
    setMultiPrice() {
        if (!this.supply_price) return this.$message.error("请输入供应链价");
        if (!this.model_item_ids.length)
            return this.$message.error("请选择规格");
        if (!this.supply_price_list.length)
            return this.$message.error("请选择商户");
        this.setSupplyPrice();
    }
    async setSupplyPrice() {
        await this.$confirm("确定修改吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        });
        apiSupplyModelSetPrice({
            model_item_ids: this.model_item_ids,
            supply_price_list: this.supply_price_list,
        }).then((res: any) => {
            this.specDialogVisible = false;
            this.getList();
        });
    }
    /** E Methods **/

    /** S ods **/
    created() {
        this.getModelList();
        this.getShopList();
        this.getList();
    }
}
